// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"f71090eaa7cd1188bbf4","532":"701783926acc90e628f0","678":"ae6316850bd73c0b70ca","883":"3ddbf335f50ff91f4436"}[chunkId] + ".js";
};